import React from "react";

const DatePicker: React.FC<{
  name: string;
  label: string;
  value?: any;
  status?: string;
  min?: any;
  max?: any;
  minDateToday?: boolean;
  disabled?: boolean;
  onChange?: any;
}> = (props) => {
  const dateToday = () => {
    let date = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T")[0];
    return date;
  };

  const datePickerChangeHandler = (event: any) => {
    const dateTodayString = dateToday();
    props.onChange && props?.onChange(event);
  };

  return (
    <div className={`input-container ${props.status}`}>
      <label>{props.label}</label>
      <input
        name={props.name}
        type="date"
        placeholder={props.label}
        value={props.value}
        disabled={props.disabled || false}
        onChange={(event) => datePickerChangeHandler(event)}
        min={props.min ? props.min : dateToday()}
        max={props.max ? props.max : ""}
      />
    </div>
  );
};

export default DatePicker;
